import script from "./WorkflowNodePalette.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowNodePalette.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowNodePalette.vue?vue&type=style&index=0&id=c5d93e56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5d93e56"]])

export default __exports__